<div class="form-group">
  <small *ngIf="label">{{label}}</small>
  <div>
    <ng-container *ngIf="controlName">
      <textarea placeholder={{placeholder}} [disabled]="isDisabled" [readonly]="isDisabled" [(ngModel)]="model[bindValue]" (ngModelChange)="ModelChange()" [required]="isRequired" [formControl]="controlName" (keyup.enter)="onKeyUp()" style="font-size: 10px; width: 100%;" [attr.rows]="rows">
    </textarea>
    </ng-container>

    <ng-container *ngIf="!controlName">
      <textarea placeholder={{placeholder}} [disabled]="isDisabled" [readonly]="isDisabled" [(ngModel)]="model[bindValue]" (ngModelChange)="ModelChange()" [required]="isRequired" (keyup.enter)="onKeyUp()" style="font-size: 10px; width: 100%;" [attr.rows]="rows">
    </textarea>
    </ng-container>
  </div>
  <small *ngIf="isRequired" class="text-muted  validator-information">Pole wymagane</small>
</div>